<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、
          <a @click="to(item)">结算数量质量</a>
        </span>
        <span v-else>结算数量质量</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <div style="padding-left: 16px;">
            <span class="desc">系统合同号：{{ item.number }}</span>
            <span class="desc" v-if="item.settlement_quantity_basis">结算数量依据：{{ item.settlement_quantity_basis }}</span>
            <span class="desc" v-if="item.settlement_quantity">结算数量：{{ item.settlement_quantity | numberFormat }} {{ dictionaries.unit[item.settlement_unit] }}</span>
            <span class="desc" v-if="item.has_deduction_item">是否存在扣减项：{{ item.has_deduction_item ? '是' : '否' }}</span>
            <span class="desc" v-if="item.has_deduction_item">扣减数量：{{ item.deduction_quantity | numberFormat }}{{ dictionaries.unit[item.unit] }}</span>
            <span class="desc" v-if="item.final_settlement_quantity">最终结算数量：{{ item.final_settlement_quantity | numberFormat }}</span>
            <span class="desc" v-if="item.settlement_quality_basis">结算质量依据：{{ item.settlement_quality_basis }}</span>
            <span class="desc" v-if="item.settlement_quality">结算质量：{{ item.settlement_quality | numberFormat }}</span>
            <span class="desc" v-if="item.has_quality_deduction">是否存在质量扣款：{{ item.has_quality_deduction ? '是' : '否' }}</span>
            <span class="desc" v-if="item.has_quality_deduction">扣款总金额：{{ item.total_deduction_amount | numberFormat }} {{ dictionaries.currency[item.currency] }}</span>
            <span class="desc" v-if="item.settlement_pricing_currency">结算币种：{{ dictionaries.currency[item.settlement_pricing_currency] || '' }}</span>
            <span class="desc" v-if="item.settlement_unit_price">结算单价：{{ item.settlement_unit_price | numberFormat }}</span>
            <span class="desc" v-if="item.settlement_exchange_rate">结算汇率：{{ item.settlement_exchange_rate | numberFormat }}</span>
            <span class="desc" v-if="item.settlement_amount">结算金额：{{ item.settlement_amount | numberFormat }}</span>
            <span class="desc">购销货品：
              <a-popover :title="item.sell_contract_product_name">
                <template slot="content">
                  <div style="width: 400px;">
                    <a-row :gutter="[16,16]">
                      <a-col :span="24" v-for="pp in item.product_parameter" :key="pp.id">
                        <span class="important-content">实际值：{{ pp.value }}（合同：{{ pp.name }} {{ dictionaries.trade_value_compare_symbol[pp.symbol] }} {{ pp.standard_value }}）</span>
                      </a-col>
                    </a-row>
                  </div>
                </template>
                <a>{{ item.sell_contract_product_name }}</a>
              </a-popover>
            </span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_settlement', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>

          </div>
          <div style="padding-left: 16px;" v-if="edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'settlement')">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'settlement')">
                <span>删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_settlement', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div v-if="item.attachment && item.attachment.length > 0">
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="2" header="附件" :style="customStyle">
                <a v-for="(attachment) in item.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'

export default {
  name: 'SettlementInfo',
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      un_approval_needed_text: '未开启审批',
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    to (item) {
      const path = '/trade/settlement'
      this.$router.push({ path: path, query: { id: item.id } })
    },
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
